(function($) {

	$.hrFix = function () {
		$('#main-content hr').each(function() {
			var hr = $(this);
			hr.replaceWith('<div class="custom-hr"><div class="icon"><svg viewBox="0 0 270 390" xmlns="http://www.w3.org/2000/svg"><path class="st0" d="M135 198.9C6 352.5 106.3 390 106.3 390 64.4 324.4 135 262.2 135 262.2s70.6 62.2 28.7 127.8c0 0 100.3-37.5-28.7-191.1z"/><path class="st1" d="M135 300.4c-60.5 72-8.5 89.6-8.5 89.6-19.6-30.7 8.5-59.9 8.5-59.9s28.1 29.2 8.5 59.9c0 0 52-17.6-8.5-89.6z"/><path class="st2" d="M135 0c-267.3 323.3-55.1 390-55.1 390C-6.7 280.4 135 124.5 135 124.5S276.7 280.4 190.1 390c0 0 212.2-66.7-55.1-390z"/></svg></div></div>');
		});
	};

	$(document).ready(function() {
		$.hrFix();
	});

})( jQuery );
